angular
  .module('blacklist')
  .component('blacklist', {
    template: require('./blacklist.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService', 'uiGmapGoogleMapApi',
      function BlacklistViewController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService, uiGmapGoogleMapApi) {
        $scope.doLogout = $rootScope.gLogout;
        $rootScope.mainmenu = 'service';
        $rootScope.menu = 'blacklist';

        this.map = { control: {}, center: { latitude: 37.50980, longitude: 127.03756 }, zoom: 13 };

        const APIURL = envService.read('apiUrl'); // eslint-disable-line
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }

        this.targetTbCityId = '-1';
        this.modifyMode = false;
        $resource(`${APIURL}/admin/maps/cities`).get({}, (data) => {
          this.cities = data.cities;
        }, (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
        $resource(`${APIURL}/admin/maps/blacklist`).get().$promise
          .then((data) => {
            this.totalCount = data.count;
            this.blacklists = data.blacklists;
          })
          .catch((err) => {
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        this.paging = (page) => {
          this.targetPage = page;
          $resource(`${APIURL}/admin/maps/blacklist`).get({ PAGE: page - 1, TB_CITY_ID: this.targetTbCityId }, (data) => {
            this.totalCount = data.count;
            this.blacklists = data.blacklists;
          }, (err) => {
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };
        this.view = (blacklist) => {
          this.modifyMode = false;
          this.viewBlacklist = {};
          angular.copy(blacklist, this.viewBlacklist);
          this.viewBlacklist.TB_CITY_ID = this.viewBlacklist.TB_CITY_ID.toString();
          this.viewBlacklist.TB_AREA_ID = this.viewBlacklist.TB_AREA_ID.toString();
          this.viewBlacklist.LEVEL = this.viewBlacklist.LEVEL.toString();
          jQuery('#modal-view-blacklist').modal('show');

          const path = blacklist.POLYLINE.replace('\n', '\\n');
          const color = '#5694cc';
          const polyline = new google.maps.Polygon({
            path: google.maps.geometry.encoding.decodePath(path),
            geodesic: true,
            strokeColor: color,
            fillColor: color,
            strokeOpacity: 1.0,
            fillOpacity: 0.3,
            strokeWeight: 2,
          });
          polyline.setMap(this.map.control.getGMap());
          // Modal에서 사용시 Drawing이 안되서 refresh를 trigger 해줌
          setTimeout(() => {
            google.maps.event.trigger(this.map.control.getGMap(), 'resize');
            this.map.control.getGMap().setCenter(polyline.getPath().getAt(0));
            this.map.control.getGMap().setZoom(15);
          }, 1000);
        };
        this.modify = () => {
          this.modifyMode = true;
          $resource(`${APIURL}/admin/meta/blacklist/add`).get().$promise
            .then((data) => {
              this.meta = data;
              // to update area list of selected city
              this.selectCity();
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.selectCity = () => {
          const selectedCities = this.cities.filter(city => parseInt(city.ID, 10) === parseInt(this.viewBlacklist.TB_CITY_ID, 10));
          console.log(selectedCities);
          this.viewBlacklist.CITY_NAME = selectedCities[0].NAME;
          this.areas = this.meta.areas.filter(area => (parseInt(area.TB_CITY_ID, 10) === parseInt(this.viewBlacklist.TB_CITY_ID, 10)));
        };
        this.modifySubmit = () => {
          if (!this.viewBlacklist.TB_CITY_ID || this.viewBlacklist.TB_CITY_ID.length < 1) {
            alert($translate.instant('도시를 선택해주세요.'));
            return;
          }
          if (!this.viewBlacklist.TB_AREA_ID || this.viewBlacklist.TB_AREA_ID.length < 1) {
            alert($translate.instant('지역을 선택해주세요.'));
            return;
          }
          if (!this.viewBlacklist.NAME || this.viewBlacklist.NAME.length < 1) {
            alert($translate.instant('이름을 입력해주세요.'));
            return;
          }
          if (!this.viewBlacklist.POLYLINE || this.viewBlacklist.POLYLINE.length < 1) {
            alert($translate.instant('인코딩된 Polyline을 입력해주세요.'));
            return;
          }
          console.log(this.viewBlacklist);

          $resource(`${APIURL}/admin/maps/blacklist/${this.viewBlacklist.ID}`).save(this.viewBlacklist).$promise
            .then(() => {
              this.blacklists = this.blacklists.map((blacklist) => {
                if (blacklist.ID === this.viewBlacklist.ID) {
                  return this.viewBlacklist;
                }
                return blacklist;
              });
              jQuery('#modal-view-blacklist').modal('hide');
              this.modifyMode = false;
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.close = () => {
          this.modifyMode = false;
        };
        this.delete = () => {
          this.modifyMode = false;
          if (!confirm($translate.instant('정말로 삭제하시겠습니까?'))) {
            return;
          }
          $resource(`${APIURL}/admin/maps/blacklist/${this.viewBlacklist.ID}`).delete().$promise
            .then(() => {
              alert($translate.instant('삭제되었습니다'));
              this.blacklists = this.blacklists.filter(blacklist => (blacklist.ID !== this.viewBlacklist.ID));
              jQuery('#modal-view-blacklist').modal('hide');
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/blacklist/blacklist.component.js